<chip-list-select-search
  [label]="label"
  [placeholder]="placeholder"
  [control]="control"
  [optimalSearch]="optimalSearch"
  [isDisabled]="isDisabled"
  [loading]="initLoading"
  [id]="id"
  [isFetchData]="isFetchData"
  [isShowSelectAll]="isShowSelectAll"
  [isDeleteAfterEmit]="isDeleteAfterEmit"
  [isShowDeleteBtn]="isShowDeleteBtn"
  [isDefaultValue]="isDefaultValue"
  [maxTotalCount]="maxTotalCount"
  [optionTitle]="optionTitle"
  [optionValue]="optionValue"
  [hasInfiniteScroll]="hasInfiniteScroll"
  [items]="items"
  (itemsChange)="emitOptions($event)"
  [values]="values"
  (valuesChange)="emitOptionValues($event)"
>
</chip-list-select-search>
